import { render } from "./SamplingPointList.component.vue?vue&type=template&id=2d18aa3e&scoped=true&ts=true"
import script from "./SamplingPointList.component.vue?vue&type=script&lang=ts"
export * from "./SamplingPointList.component.vue?vue&type=script&lang=ts"

import "./SamplingPointList.component.vue?vue&type=style&index=0&id=2d18aa3e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d18aa3e"]])

export default __exports__